export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13092.e43e49d6.jpg";